export default __webpack_public_path__ + "static/media/Team-Meeting.cdd526cd.svg";